export default (error) => ({
	event: 'jsError',
	jsErrorInfo: {
		line: `${error.lineNumber || 0}:${error.columnNumber || 0}:${error.fileName || 0}`,
		message: `${error.app.code || 'APP'} | ${error.app.origin || 'Undefined'} | ${error.name || 'Error'}: ${error.message || 'Undefined'}`
	}
});
